import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import Popup from 'components/popup/popup';
import { useSelector } from 'react-redux';
import CustomTable from 'components/CustomTable';

const useStyles = makeStyles((theme) => ({
    contanier: {
        flex: 1,
        overflow: 'auto',
    },
    divider: {
        width: '100%',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        borderBottom: '1px solid #ddd',
        marginBottom: theme.spacing(2),
        paddingBottom: 5,
    },
    subTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: theme.spacing(2),
    },
    name: {
        fontSize: 15,
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    text: {
        fontSize: 14,
        marginBottom: theme.spacing(1),
    },
    contactTitle: {
        fontSize: 15,
        fontWeight: 'bold',
        borderBottom: '1px solid #ddd',
        marginBottom: theme.spacing(1),
        paddingBottom: 5,
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginLeft: {
        marginLeft: theme.spacing(2),
    },
    email: {
        marginLeft: theme.spacing(1),
        marginTop: '-2px',
    },
    mutiCluster: {
        marginTop: theme.spacing(4),
    },
}));

const NewsContactPopup = (props) => {
    const classes = useStyles();

    const contactList = useSelector((state) => state.system.contactList);
    const systemNews = useSelector((state) => state.system.systemNewsAndBroadCastMsg?.news);

    const [title, setTitle] = useState('News');
    const [popupHeight, setPopupHeight] = useState('40%');
    const columns = [
        { field: 'officeName', headerName: 'CREC/IRB Office', width: 150 },
        //{ field: 'contact', headerName: 'Contact', width: 330 },
        {
            field: 'email',
            headerName: 'Email',
            width: 300,
            renderCell: (params) => {
                return <Typography color="primary">{params.row.email}</Typography>;
            },
        },
    ];
    const rows = contactList;

    useEffect(() => {
        if (props.popupType === 'news') {
            setTitle('News');
        } else {
            setTitle('Contacts');
            setPopupHeight('700px');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const cancel = () => {
        props.setOpenPopup(false);
    };
    return (
        <Popup
            height={popupHeight}
            width="800px"
            title={title}
            open={props.openPopup}
            footerActions={[{ label: 'Close', clicked: cancel }]}
            closePopup={cancel}
        >
            <Grid className={classes.contanier}>
                {props.popupType === 'news' ? (
                    <Grid container>
                        <Grid container>
                            <pre
                                style={{
                                    whiteSpace: 'break-spaces',
                                }}
                            >
                                {systemNews}
                            </pre>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container>
                        <Grid container>
                            <Grid container className={classes.contactTitle}>
                                CCO / Central IRB:
                            </Grid>
                            <Grid container className={classes.text} alignItems="center">
                                Tel: 2300 8472 / 2300 7054
                                <div style={{ marginLeft: 110 }}>
                                    Email: <span style={{ color: '#3f51b5', marginLeft: 5 }}>hacco@ha.org.hk</span>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.marginTop}>
                            <Grid container className={classes.contactTitle}>
                                Central IRB – PAED Panel:
                            </Grid>
                            <Grid container className={classes.text} alignItems="center">
                                Tel: 3513 3193 / 3513 6485
                                <div style={{ marginLeft: 110 }}>
                                    Email: <span style={{ color: '#3f51b5', marginLeft: 5 }}>hkch.ro@ha.org.hk</span>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.marginTop}>
                            <Grid container className={classes.contactTitle}>
                                HKU/HA HKW IRB:
                            </Grid>
                            <Grid container className={classes.text} alignItems="center">
                                Tel: 2255 4086 / 2255 3923 / 2255 6788
                                <div style={{ marginLeft: 30 }}>
                                    Email: <span style={{ color: '#3f51b5', marginLeft: 5 }}>hkwirb@ha.org.hk</span>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.marginTop}>
                            <Grid container className={classes.contactTitle}>
                                The Joint CUHK-NTEC CREC:
                            </Grid>
                            <Grid container className={classes.text} alignItems="center">
                                Tel: 3505 3935 / 3505 4275 / 2144 5926
                                <div style={{ marginLeft: 30 }}>
                                    Email: <span style={{ color: '#3f51b5', marginLeft: 5 }}>crec@cuhk.edu.hk</span>
                                </div>
                            </Grid>
                        </Grid>

                        <Grid container className={classes.marginTop}>
                            <CustomTable
                                columns={columns}
                                rows={rows}
                                allowResize
                                textAlign="left"
                                fullWidthTable={false}
                            />
                        </Grid>
                        <Grid container className={classes.marginTop}>
                            <Grid container className={classes.contactTitle}>
                                For General (HA Head Office)
                            </Grid>
                            <Grid container className={classes.text} alignItems="center">
                                Tel: 2300 8397
                                <div style={{ marginLeft: 186 }}>
                                    Email: <span style={{ color: '#3f51b5', marginLeft: 5 }}>crerportal@ha.org.hk</span>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Popup>
    );
};

export default NewsContactPopup;
